import { Inject, Injectable, Injector } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  Produto,
  Produto as ProdutoResponse,
  ProdutoRequest,
  StringifiedResponse,
} from '../models/product.model';
import { SelectClientService } from '../../select-client/select-client.service';
import { UtilsBaseApiService } from '@brunsker/libs/core/utils/base-api';
import { ENVIRONMENT_TOKEN, Environment } from '@brunsker/libs/core/utils/http-log-interceptor/src';

@Injectable({
  providedIn: 'root',
})
export class ProdutosServiceApiService extends UtilsBaseApiService<ProdutosServiceApiService> {
  readonly INFORMATION_PRODUCTS_EXTENSION = 'INFPRODUTOS';
  readonly BY_ID_EXTENSION = 'byId';

  constructor(
    @Inject(ENVIRONMENT_TOKEN) readonly environment: Environment,
    override readonly injector: Injector,
    private selectClientService: SelectClientService
  ) {
    super('produtos', injector, environment.BASE_API_URL);
  }

  getInformationProduct(
    request: ProdutoRequest
  ): Observable<ProdutoResponse[]> {
    return this.httpClient
      .post<StringifiedResponse>(
        `${this.BASE_URL}${this.CONTEXT}/${this.INFORMATION_PRODUCTS_EXTENSION}`,
        {
          tipobusca: 0,
          pesquisa: request.search || [],
          codigofilial: 2,
          seqcliente: 4,
          codcli: 4,
          intervalo: request.intervalo,
          linhainicial: 0,
        }
      )
      .pipe(
        map((response) => {
          let JsonParsed = JSON.parse(response.produto.json) as Produto[];
          const hasCliente =
            this.selectClientService.getCurrentClientInSessionStorage();

          if (hasCliente && hasCliente.data) {
            JsonParsed = JsonParsed.map((produto) => {
              const clienteIsVarejo = hasCliente.data.atacarejo === '2';

              if (clienteIsVarejo) {
                const morePrice = +produto.PRECO * 0.1;
                produto.PRECO = `${+produto.PRECO + morePrice}`;
              }

              if (+hasCliente.formaDeEntrega === 2) {
                produto.PRECO = `${+produto.PRECO + +produto.PRECO * 0.03}`;
              }

              return produto;
            });
          }
          return JsonParsed;
        })
      );
  }

  getProductById(id: number): Observable<ProdutoResponse> {
    return this.httpClient.get<ProdutoResponse>(
      `${this.BASE_URL}${this.CONTEXT}/${this.BY_ID_EXTENSION}/${id}`
    );
  }
}
